import { Outlet } from "react-router-dom";
import { TriggerTypesList } from "./TriggerList";
import TriggerTypeForm from "./TriggerForm";

export const triggerTypesRoutes = [
  {
    path: "trigger-types",
    element: Outlet,
    children: [
      {
        path: "",
        element: TriggerTypesList,
      },
      {
        path: "add",
        element: TriggerTypeForm,
      },
      {
        path: "edit/:id",
        element: TriggerTypeForm,
      },
    ],
  },
];
